import { c as _c } from "react/compiler-runtime";
import { saveLogin } from "@website/hooks/auth-manager";
import { B2BInquiry, B2BOtp } from "@website/widget/login/components";
import { LoginPropertiesType, LoginStepType } from "@website/widget/login/login.types";
import { useB2BLogin } from "@website/widget/login/use-b2b-login";
import { FC } from "react";
export const LoginB2B: FC<LoginPropertiesType> = () => {
  const $ = _c(15);
  const {
    step,
    setStep,
    userData,
    setUserData
  } = useB2BLogin();
  let t0;
  if ($[0] !== setStep) {
    t0 = step_0 => {
      setStep(step_0);
    };
    $[0] = setStep;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setStepHandler = t0;
  const onEndAuth = _temp;
  let t1;
  if ($[2] !== setStepHandler || $[3] !== setUserData || $[4] !== step || $[5] !== userData) {
    t1 = step === "phone-number" && <B2BInquiry setStep={setStepHandler} setUserData={setUserData} userData={userData} />;
    $[2] = setStepHandler;
    $[3] = setUserData;
    $[4] = step;
    $[5] = userData;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== setStepHandler || $[8] !== setUserData || $[9] !== step || $[10] !== userData) {
    t2 = step === "otp" && <B2BOtp onEndAuth={onEndAuth} setStep={setStepHandler} setUserData={setUserData} userData={userData} />;
    $[7] = setStepHandler;
    $[8] = setUserData;
    $[9] = step;
    $[10] = userData;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== t1 || $[13] !== t2) {
    t3 = <div className="w-full">{t1}{t2}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
function _temp(accessToken, refreshToken) {
  if (accessToken) {
    saveLogin({
      accessToken,
      refreshToken
    });
    window.location.href = "/";
  }
}